import React, { useEffect, useState, useMemo, memo } from 'react';
import * as uuid  from 'uuid';

import { useSelector } from 'react-redux';
import { fromJS } from 'immutable';

import { DefaultRequest } from 'scripts/api';
import { getResourceTo } from 'react/utils/utils.js';

import HeaderContainer from './HeaderContainer';
import PageDetails from './PageDetails';
import RightOptions from './RightOptions';

function Header() {
  const [applications, setApplications] = useState([]);
  const tabs = useSelector((state) => state.tabs);

  const hasDescriptionResource = (resource, key) => resource !== `${key}.subtitle`;

  const getDescription = (tabInfo, key) => {
    const tag = tabInfo.get('tag');

    const resourceKey = getResourceTo(`${key}.subtitle`);
    const resourceTag = getResourceTo(`${tag}.subtitle`);

    if (hasDescriptionResource(resourceKey, key)) {
      return resourceKey;
    }

    if (hasDescriptionResource(resourceTag, tag)) {
      return resourceTag;
    }

    return null;
  };

  const page = useMemo(() => {
    if (!Monet.I18n) return null;

    const tabInfo = tabs.get('active', fromJS({}));
    const tabList = tabs.get('list', fromJS({}));

    const key = tabInfo.get('key', uuid);
    const title = tabList.getIn([key, 'title']);
    const hasTab = tabList.has(key);

    if (!hasTab) return null;

    return {
      key,
      name: getResourceTo(`${title}`),
      description: getDescription(tabInfo, key)
    };
  }, [tabs]);

  useEffect(() => {
    new DefaultRequest({
      method: 'GET',
      url: '/MyApps',
      success: (response) => {
        const translatedApplications = response?.map(app => ({
          ...app,
          appName: getResourceTo(app.appName)
        }));

        setApplications(translatedApplications);
      }
    }).send();
  }, []);

  return (
    <HeaderContainer projectName="Live">
      <PageDetails page={page} />
      <RightOptions applications={applications} />
    </HeaderContainer>
  );
}

export default memo(Header);
